'use strict';

import Api from "./Api";

export default class Company extends Api {

    static getList(page = 1, perPage = 10) {
        const url = this.url + 'company/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
            },
        });
    }

    static get(id) {
        const url = this.url + 'company/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'company/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'company/update';

        return this.getAxios().post(url, data);
    }

    static updateAvatar(id, file) {
        const url = this.url + 'company/upload-avatar';

        const form = new FormData();
        form.append('id', id);
        form.append('avatar', file);

        return this.getAxios().post(url, form);
    }

}